import React, { useContext } from 'react'
import { CommentingContextValue } from 'sierra-client/domain/commenting/types'

export const CommentingContext = React.createContext<CommentingContextValue | undefined>(undefined)

export const useCommentingContext = (): CommentingContextValue | undefined => useContext(CommentingContext)
